import GetAllResourceEntriesInteractor from "../../core/interactor/app/crud/GetResourceEntriesInteractor";
import Constants from "../common/Constants";
import { ICaseLawDocument } from "../model/CaseLawDocument";
import CaseLawDocumentMapper from "../service/CaseLawDocumentMapper";
import CaseLawDocumentParamMapper from "../service/CaseLawDocumentParamMapper";

export default class GetInvalidatedCaseLawDocumentsInteractor {
  private resource: GetAllResourceEntriesInteractor<ICaseLawDocument>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute(caseLawDocumentId: number) {
    return this.resource.execute(
      `${Constants.endpointBasePath}/${caseLawDocumentId}/invalidated`,
      CaseLawDocumentMapper,
      CaseLawDocumentParamMapper
    );
  }
}
